module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/@moveinc/rdc-tracking/~/babel-runtime/core-js/object/set-prototype-of.js
// module id = 996
// module chunks = 48 49 50